<template>
  <div :class="`padding-16 border-radius-8 flex-center ${bg}`" v-if="loading">
    <b-spinner small />
    <strong class="margin-right-8" v-text="text" />
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "درحال دریافت اطلاعات...",
    },
    bg: {
      type: String,
      default: "background-complementary-50",
    },
  },
};
</script>